import { usePath } from '@resultadosdigitais/front-hub/react'
import { Button, ButtonGroup, Text } from '@resultadosdigitais/tangram-components'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components/macro'
import MFAadoptionScreenAdminImage from './header_admin_image.svg'
import MFAadoptionScreenImage from './header_image.svg'

const Container = styled.div`
  box-shadow: var(--shadow-sm);
  background: var(--color-white);
  border-radius: var(--border-radius-rounded);
  will-change: opacity, transform;
  max-width: 600px;
  margin-top: var(--size-spacing-05);

  > * + * {
    margin-top: var(--size-spacing-04);
  }
  @media screen and (min-width: 768px) {
    margin-top: var(--size-spacing-02);
  }
`

const StyledImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: stretch;
  background-color: #212429;
  min-height: 200px !important;
  @media (max-width: 425px) {
    min-height: 136px !important;
  }
`

const StyledImage = styled.img`
  width: 100% !important;
  min-height: 200px !important;
  @media (max-width: 425px) {
    min-height: 136px !important;
  }
`

const StyledTextContainer = styled.div`
  padding: var(--size-spacing-03) var(--size-spacing-05);
`

const StyledButtonGroup = styled(ButtonGroup)`
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: var(--size-spacing-03);
`
const StyledMainButtonGroup = styled(ButtonGroup)`
  display: flex;
  justify-content: flex-end;
  align-items: stretch;
  width: 100%;
  padding: 0 var(--size-spacing-05) var(--size-spacing-05) 0;
`

export default function MFAadoptionScreen({ redirectTo, isAdmin }) {
  const { t } = useTranslation()
  const assetPath = usePath()

  function continueToRedirect() {
    window.location.assign(redirectTo)
  }

  function redirectToSecuritySettings() {
    if (isAdmin) {
      window.location.assign('/settings/security_center?open_drawer=true')
    } else {
      window.location.assign('/settings/security/mfa_app')
    }
  }

  function getTranslationKeyByAdmin() {
    return isAdmin ? 'Admin' : 'User'
  }

  function getHeaderImageKeyByAdmin() {
    return isAdmin ? MFAadoptionScreenAdminImage : MFAadoptionScreenImage
  }

  return (
    <Container>
      <StyledImageContainer>
        <StyledImage src={assetPath(getHeaderImageKeyByAdmin())} alt={t('DeviceRegistrationForm.Acessibility.DeviceSuccesAlt')} />
      </StyledImageContainer>
      <StyledTextContainer>
        <Text token={Text.tokens.TEXT_XL_BOLD}>{t(`MFAadoptionScreen.${getTranslationKeyByAdmin()}.Title`)}</Text>
        <Text token={Text.tokens.TEXT_MD_REGULAR}>{t(`MFAadoptionScreen.${getTranslationKeyByAdmin()}.Description`)}</Text>
      </StyledTextContainer>
      <StyledMainButtonGroup>
        <StyledButtonGroup>
          <Button onClick={() => continueToRedirect()} kind={Button.kinds.tertiary}>
            {t('MFAadoptionScreen.RememberMeButton')}
          </Button>
          <Button onClick={() => redirectToSecuritySettings()}>{t('MFAadoptionScreen.ActiveButton')}</Button>
        </StyledButtonGroup>
      </StyledMainButtonGroup>
    </Container>
  )
}
